// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guide-map-popup-wrapper{display:flex;flex-direction:column;margin:0!important;position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);max-height:calc(100% - 30px);max-width:calc(100% - 30px);border-radius:8px!important}.guide-map-popup-wrapper .el-dialog__footer,.guide-map-popup-wrapper .el-dialog__header{display:none}.guide-map-popup-wrapper .el-dialog__body{padding:0!important;word-break:normal!important;flex:1}", ""]);
// Exports
module.exports = exports;
